import { useAuth } from '../app/providers/AuthProvider'

const Profile = () => {
  const { user } = useAuth()

  return (
    <div className="space-y-8">
      <div className="flex flex-col gap-2">
        <div className="text-xs uppercase tracking-widest text-slate-500">Profile</div>
        <h1 className="text-3xl font-semibold">Account profile</h1>
        <p className="text-slate-600">Manage identity and view account details.</p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <div className="rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-sm">
          <div className="text-sm font-semibold">Identity</div>
          <div className="mt-4 space-y-3 text-sm">
            <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3">
              Name: {user?.name || 'Not set'}
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3">
              Email: {user?.email || 'Not set'}
            </div>
          </div>
          <button className="mt-6 rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
            Edit profile
          </button>
        </div>

        <div className="rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-sm">
          <div className="text-sm font-semibold">Security</div>
          <p className="mt-2 text-sm text-slate-600">Update password and manage sessions.</p>
          <div className="mt-4 flex flex-col gap-3 sm:flex-row">
            <button className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
              Change password
            </button>
            <button className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
              Active sessions
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
